import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=4341041a&"
import script from "../../services/admin/forget-password.js?vue&type=script&lang=js&"
export * from "../../services/admin/forget-password.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports